export default function NotFound() {
  return (
    <section
      className="relative mx-auto flex min-h-[80vh] max-w-4xl flex-col items-center justify-center overflow-hidden px-5 py-28 text-center"
      data-testid="not-found-page"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 select-none font-display text-[40vw] leading-none text-white/[0.04] md:text-[24rem]"
      >
        404
      </div>
      <p className="relative font-mono text-xs uppercase tracking-[0.3em] text-cheddar">
        Error 404 — Salah Belok
      </p>
      <h1 className="relative mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-cream sm:text-5xl lg:text-6xl">
        Halaman ini kelewat jalur.
      </h1>
      <p className="relative mt-5 max-w-md text-base leading-relaxed text-sand">
        Halaman yang kamu cari nggak ada di sini — mungkin sudah pindah lapak.
        Balik ke beranda atau langsung intip menu.
      </p>
      <div className="relative mt-8 flex flex-wrap justify-center gap-4">
        <a href="/" data-testid="notfound-home-button" className="btn-primary px-7 py-3.5 text-sm">
          Kembali ke Beranda
        </a>
        <a href="/menu/" data-testid="notfound-menu-button" className="btn-ghost px-7 py-3.5 text-sm">
          Lihat Menu
        </a>
      </div>
    </section>
  );
}
